<template>
    <div id="bill">
        <div v-for="(item,i) in list" :key="i">
            <div class="date">
                {{ item.date | sliceDate}}
                周{{item.weekDay | week}}
            </div>
            <div class="bill_box">
                <div class="bill_item" v-for="(it,index) in item.data" :key="index">
                    <div class="line line_one">
                        <div class="otype">
                            <!-- 1、3  2、4  6-->
                            <span v-if="it.otype == 1">充值</span>
                            <span v-else-if="it.otype == 2">提现</span>
                            <span class="red" v-else-if="it.otype == 3">反悔</span>
                            <span v-else-if="it.otype == 4">提现失败</span>

                            <span v-else-if="it.otype == 7">交易取消退款</span>
                            <span v-else-if="it.otype == 8">买家取消订单服务费</span>
                            <span v-else-if="it.otype == 9">买家取消订单退还金额</span>
                        </div>
      
                        <div class="yen">
                            <span class="red" v-if="it.otype == 1">
                                +&nbsp;&yen;{{ it.amount }}
                            </span>
                            <span class="success" v-if="it.otype == 2">
                                -&nbsp;&yen;{{ it.amount }}
                            </span>
                            <span class="ing" v-if="it.otype == 3">
                                -&nbsp;&yen;{{ it.amount }}
                            </span>

                            <span class="red" v-else-if="it.otype == 4">
                                -&nbsp;&yen;{{ it.amount }}
                            </span>

                            <span class="red" v-if="it.otype == 7">
                                +&nbsp;&yen;{{ it.amount }}
                            </span>
                            <span class="success" v-else-if="it.otype == 8">
                                -&nbsp;&yen;{{ it.amount }}
                            </span>
                            <span class="red" v-else-if="it.otype == 9">
                                +&nbsp;&yen;{{ it.amount }}
                            </span>
                        </div>
                    </div>
                    <div class="line line_mid" v-if="it.fail_msg">
                        审核失败原因：{{it.fail_msg}}
                        <span v-if="it.fail_type == 1">,请修改后重新提审。<a href="javascript:;" @click="gotoModifyAccount(it.recv_account_id)">点击前往修改></a></span>
                    </div>
                    <div class="line line_two">
                        <div class="item_date">{{ it.ctime.slice(0,16) }}</div>
                        <div class="yen">保证金余额：&yen;{{ it.margin_after }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'bill-item2',
        data() {
            return {

            }
        },
        filters: {
            sliceDate(date) {
                if (date) {
                    return date.slice(5, 10)
                }
            },
            week(i) {
                if (i == 0) {
                    return '日'
                } else if (i == 1) {
                    return '一'
                } else if (i == 2) {
                    return '二'
                } else if (i == 3) {
                    return '三'
                } else if (i == 4) {
                    return '四'
                } else if (i == 5) {
                    return '五'
                } else if (i == 6) {
                    return '六'
                }
            }
        },
        props: {
            list: {
                type: Array,
                default: []
            }
        },
        methods: {
            gotoModifyAccount(id) {
                if(id) {
                    this.$router.push({
                        name: "bind.account",
                        query: {
                            action: 'modify',
                            id
                        },
                    });
                }else {
                    this.$router.push({
                        name: "account.manage",
                    });
                }
            }
        }
    }
</script>
<style lang="less" scoped>
#bill {
   .date {
        color: #555;
        padding: 1rem 1.3rem .9rem;
        font-size: 1.4rem;
   }
   .bill_box {
    background-color: #fff;
    border-radius: 1rem;
    padding: 0 1.4rem;
    margin-bottom: .4rem;
    .bill_item {
        padding: 1rem 0;
        border-bottom: 1px solid #eee;
        &:nth-last-child(1) {
            border: none;
        }
    }
    .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .line_one {
        margin-bottom: 0.8rem;
        .otype {
            font-size: 1.5rem;
            color: #000;
            .red {
                color: var(--red);
            }
        }
        .yen {
            font-size: 1.5rem;
            .ing {
                color: var(--ing);
            }
            .red {
                color: var(--red);
            }
            .success {
                color: var(--success);
            }
        }
    }
    .line_mid {
        margin-bottom: 0.8rem;
        font-size: 1.4rem;
        a {
            color: #2f2fff;
        }
    }
    .line_two {
        color: #999;
    }
   }
}
</style>